export const calculateScrollPercent = (): string => {
  const totalHeight = document.body.scrollHeight - window.innerHeight;
  const scrollPosition = window.scrollY;
  return `${Math.round((scrollPosition / totalHeight) * 100)}%`;
};
